import { isBrowser as e } from "./is-browser.js";
const t = e && "loading" in document.createElement("img");
export {
  t as isImageSupportNativeLazy
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/env/is-native-lazy-load.js
// module id = 1626
// module chunks = 67